/**
 * Decodes a JWT's payload WITHOUT verifying the signature — the Labs Live
 * server is the trust boundary; client-side decoding is for UX only (token
 * expiry, LaunchDarkly identity). Returns undefined for malformed tokens.
 */
export const decodeJwtPayload = (token: string): Record<string, unknown> | undefined => {
    const parts = token.split(".");
    if (parts.length < 2) {
        return undefined;
    }
    try {
        const payload: unknown = JSON.parse(atob(parts[1].replace(/-/g, "+").replace(/_/g, "/")));
        if (typeof payload !== "object" || payload === null) {
            return undefined;
        }
        return payload as Record<string, unknown>;
    } catch {
        return undefined;
    }
};
